import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=7f2cc544&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=7f2cc544&lang=less&scoped=true&"
import style1 from "./BaseInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2cc544",
  null
  
)

export default component.exports